module.exports = __webpack_public_path__ + "img/img-down.fbd62625.svg";